import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { ProjectMeta } from '@/classes/ProjectMeta';

@Module({
  namespaced: true
})
class CurrenProjectModule extends VuexModule {
  private currentProject: ProjectMeta | null = null;
  private panelState: number[] = [];

  @Action
  savePanelState(payload: number []) {
    this.context.commit('setPanelState', payload);
  }

  @Action
  async setCurrentProject(project: ProjectMeta) {
    this.context.commit('setProject', project);
    await this.context.dispatch('scenario/loadFieldLocales', project.typeRef, { root: true });
    await this.context.dispatch('scenarioRules/updateRules', project, { root: true });
    await this.context.dispatch('siteMap/loadSiteMapLocales', project.typeRef, { root: true });
    await this.context.dispatch('siteMap/loadSiteMapSpecifications', project.typeRef, { root: true });
  }

  @Mutation
  private setProject(project: ProjectMeta | null) {
    this.currentProject = project;
  }

  @Mutation
  setPanelState(payload: number []) {
    this.panelState = payload;
  }

  get getCurrentProject() {
    return this.currentProject;
  }
  get getPanelState() {
    return this.panelState;
  }
}
export default CurrenProjectModule;
